module.exports = __webpack_public_path__ + "img/banner-princiapal.7be95689.png";